import type { MessageKey } from './en.js';

/** Français. La langue de la brigade : poste, couverts, mise en place. */
export const fr: Record<MessageKey, string> = {
  'common.loading': 'Chargement…',
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement…',
  'common.saved': 'Enregistré.',
  'common.cancel': 'Annuler',
  'common.edit': 'Modifier',
  'common.delete': 'Supprimer',
  'common.reallyDelete': 'Vraiment supprimer ?',
  'common.remove': 'Retirer',
  'common.reallyRemove': 'Vraiment retirer ?',
  'common.add': 'Ajouter',
  'common.create': 'Créer',
  'common.creating': 'Création…',
  'common.none': 'Aucun',
  'common.anyone': "N'importe qui",
  'common.name': 'Nom',
  'common.email': 'E-mail',
  'common.password': 'Mot de passe',
  'common.station': 'Poste',
  'common.anyStation': 'Tous les postes',
  'common.anywhere': 'Partout',
  'common.optional': 'Facultatif',
  'common.moveUp': 'Monter',
  'common.moveDown': 'Descendre',
  'common.unit': 'Unité',
  'common.howMuch': 'Combien',
  'common.amount': 'Quantité',
  'common.working': 'Calcul…',
  'common.dismiss': 'Fermer',
  'common.tryAgain': 'Réessayer',
  'common.loadFailed': 'Impossible de charger. Vérifiez la connexion et réessayez.',

  'error.generic': "Quelque chose s'est mal passé.",
  'error.notFound': 'Ce n’est plus là. Quelqu’un l’a peut-être supprimé.',
  'error.validationFailed': 'Quelque chose n’est pas bien rempli. Vérifiez et réessayez.',
  'error.alreadyExists': 'Cela existe déjà.',
  'error.stillReferenced': 'C’est encore utilisé ailleurs, donc impossible de le supprimer.',
  'error.invalidData': 'Cette valeur n’est pas autorisée ici.',
  'error.writeInProgress':
    'Cette modification est en cours d’enregistrement. Réessayez dans un instant.',
  'error.backupFileMissing': 'Joignez le fichier de sauvegarde.',
  'error.onedriveNotConnected': 'Connectez d’abord OneDrive.',
  'error.nasAddressNeeded': 'Saisissez l’adresse du NAS où envoyer les sauvegardes.',
  'error.fileTooLarge': 'Ce fichier est trop volumineux.',
  'error.unknownTimeZone': 'Ce serveur ne connaît pas ce fuseau horaire.',
  'error.alreadySetUp': 'Ce serveur est déjà configuré.',
  'error.imageType': 'Utilisez une image JPEG, PNG ou WebP.',
  'error.imageMissing': 'Aucune image n’a été jointe.',
  'error.notADish': 'Seul un plat a une fiche plat.',
  'error.logoTooLarge': 'Ce logo dépasse 2 Mo.',
  'error.photoTooLarge': 'Cette image dépasse 8 Mo.',
  'error.taskNotYours': 'Vous ne pouvez mettre que votre propre nom sur une ligne.',
  'error.taskChefOnly':
    'Vous pouvez commencer et terminer une ligne, mais seul un chef peut en changer le texte.',
  'error.staffRank': 'Seul un administrateur peut gérer le personnel de votre rang ou au-dessus.',
  'error.adminNeedsPassword':
    'Un administrateur a besoin d’une adresse e-mail et d’un mot de passe, pas seulement d’un code PIN.',
  'error.passwordNeedsEmail': 'La connexion par mot de passe demande une adresse e-mail.',
  'error.noWayToSignIn':
    'Cette personne n’aurait plus aucun moyen de se connecter. Donnez-lui un mot de passe ou un code PIN.',
  'error.emailTaken': 'Quelqu’un a déjà cette adresse e-mail.',
  'error.lastAdmin':
    'C’est le dernier administrateur. Nommez d’abord quelqu’un d’autre administrateur, sinon personne ne pourra gérer cette cuisine.',
  'error.cannotRemoveSelf': 'Vous ne pouvez pas supprimer votre propre compte.',
  'error.onlyDishes': 'Seuls les plats vont sur un menu : {names}.',
  'error.menuNameTaken': 'Il existe déjà un menu de ce nom.',
  'error.menuUnavailable':
    'Les allergènes de {names} ne peuvent pas être établis : il renvoie à une recette ou un ingrédient qui n’existe plus. Corrigez d’abord la recette.',
  'error.recipeGone': 'Cette recette n’existe plus.',
  'error.recipeLoop':
    '{parent} ne peut pas contenir {child}, car {child} contient déjà {parent}. Ce serait une boucle.',
  'error.scaleFailed': 'Cette recette n’a pas pu être calculée à cette taille.',
  'error.scaleUnits': 'Cette taille est dans un autre type d’unité que ce que donne la recette.',
  'error.scaleLoop':
    'Cette recette se contient elle-même, elle ne peut donc pas être mise à l’échelle.',
  'error.scaleNoPortions':
    'Cette recette n’est pas écrite en portions. Mettez-la à l’échelle par fournée ou par rendement.',
  'error.stillUsed': 'Encore utilisé par {names}. Retirez-le d’abord de celles-ci.',
  'error.alreadyInside':
    'Cet appareil est sur le réseau de la cuisine et n’a pas besoin d’approbation.',
  'error.allergensUnknown':
    'Les allergènes de cette recette ne peuvent pas être établis : il manque quelque chose ou elle renvoie à elle-même. Vérifiez ce qu’elle contient dans l’éditeur.',
  'error.nameOutsideKitchen':
    'Le certificat de la cuisine ne vaut que pour le réseau de la cuisine : des adresses comme 192.168.1.50, et des noms finissant par .local, .lan, .home ou .internal. « {name} » n’en fait pas partie.',
  'error.invalidCredentials': 'Ça ne correspond pas. Réessayez.',
  'error.accountInactive': "Ce compte n'est plus actif.",
  'error.deviceNotEnrolled':
    'La connexion par code ne fonctionne que sur une tablette enregistrée par un administrateur.',
  'error.notAuthenticated': 'Connectez-vous pour continuer.',
  'error.forbidden': 'Votre rôle ne le permet pas.',
  'error.setupToken':
    'Ce code de configuration est incorrect. Vérifiez le lien affiché lors de l’installation de Mise.',
  'error.accountLocked': 'Trop d’essais incorrects. Réessayez dans 15 minutes.',
  'error.accountLockedUntil': "Trop d'essais manqués. Réessayez après {time}.",

  'shell.unreachableTitle': 'Impossible de joindre le serveur',
  'shell.unreachableBody':
    'Vérifiez que le serveur Mise fonctionne et que cet appareil est sur le même réseau.',
  'shell.home': "Mise, aujourd'hui",
  'shell.signOut': 'Se déconnecter',
  'shell.signOutFailed': 'Impossible de se déconnecter. Vérifiez la connexion et réessayez.',
  'shell.sourceCode': 'Code source',
  'shell.language': 'Langue',
  'shell.languageKitchen': 'Langue de la cuisine ({language})',

  'nav.today': "Aujourd'hui",
  'nav.recipes': 'Recettes',
  'nav.dishes': 'Plats',
  'nav.ingredients': 'Ingrédients',
  'nav.settings': 'Réglages',
  'nav.updateAvailable': 'Une version plus récente de Mise est sortie',

  'role.admin': 'Administrateur',
  'role.head_chef': 'Chef de cuisine',
  'role.sous_chef': 'Sous-chef',
  'role.cook': 'Cuisinier',

  'recipeType.dish': 'Plat',
  'recipeType.prep': 'Préparation',
  'recipeType.component': 'Élément',

  'recipeStatus.draft': 'Brouillon',
  'recipeStatus.published': 'Publiée',
  'recipeStatus.archived': 'Archivée',

  'allergen.gluten': 'Céréales contenant du gluten',
  'allergen.crustaceans': 'Crustacés',
  'allergen.eggs': 'Œufs',
  'allergen.fish': 'Poissons',
  'allergen.peanuts': 'Arachides',
  'allergen.soybeans': 'Soja',
  'allergen.milk': 'Lait',
  'allergen.nuts': 'Fruits à coque',
  'allergen.celery': 'Céleri',
  'allergen.mustard': 'Moutarde',
  'allergen.sesame': 'Graines de sésame',
  'allergen.sulphites': 'Anhydride sulfureux et sulfites',
  'allergen.lupin': 'Lupin',
  'allergen.molluscs': 'Mollusques',

  'today.night': 'Nuit',
  'today.day': 'Jour',
  'today.progress': '{done} sur {total} faits',
  'today.progressLabel': 'Mise en place du {period} faite',
  'today.mine': 'À moi',
  'today.all': 'Tout',
  'today.nothingMine': 'Rien pour vous sur cette liste.',
  'today.nothingStation': 'Rien à ce poste.',
  'today.pending_one': "Une coche n'est pas encore arrivée au serveur.",
  'today.pending_other': '{count} coches ne sont pas encore arrivées au serveur.',
  'today.pendingStill':
    'Nouvel essai en cours. Elles restent sur cette tablette jusqu’à leur envoi.',
  'today.tickRefused': 'Une coche n’est pas passée : {reason}',

  'task.doneBy': 'Fait par {name}',

  'line.loading': 'Chargement de la brigade…',
  'line.notEnrolledTitle': "Cette tablette n'est pas enregistrée",
  'line.notEnrolledBody':
    "La connexion par code ne fonctionne que sur une tablette configurée par un administrateur. Demandez-lui de se connecter ici et de l'enregistrer depuis les Réglages.",
  'line.signInPassword': 'Se connecter avec un mot de passe',
  'line.whoIsOn': 'Qui est là ?',
  'line.nobodyHasPin':
    "Personne n'a encore de code. Un administrateur peut en créer un pour chaque cuisinier dans les Réglages.",
  'line.notOnList': 'Pas sur la liste, ou sur un ordinateur portable ?',
  'line.signInEmail': 'Se connecter avec un e-mail et un mot de passe',
  'line.signingIn': 'Connexion',
  'line.checking': 'Vérification…',
  'line.notMe': 'Pas moi',

  'login.title': 'Connectez-vous à votre cuisine',
  'login.subtitle': "Chefs et responsables, sur n'importe quel appareil.",
  'login.signIn': 'Se connecter',
  'login.signingIn': 'Connexion…',
  'login.onTheLine': 'Au passe ?',
  'login.pinLink': 'Se connecter avec votre code',
  'login.eyebrow': 'E-mail et mot de passe',
  'login.titleKitchen': 'Connexion à {kitchen}',
  'login.show': 'Afficher',
  'login.hide': 'Masquer',
  'login.forgot':
    'Mot de passe oublié ? Un administrateur peut en définir un nouveau dans les Réglages.',
  'login.tabletBody':
    'Les cuisiniers se connectent sur la tablette de cuisine : touchez votre nom, puis saisissez votre code.',
  'login.server': 'Connecté à {host}',
  'line.eyebrow': 'Tablette de cuisine',
  'line.tapNamePin': 'Touchez votre nom, puis saisissez votre code.',
  'line.enterPin': 'Saisissez votre code.',
  'line.digitsTyped_one': '{count} chiffre saisi',
  'line.digitsTyped_other': '{count} chiffres saisis',
  'line.welcome': 'Bienvenue, {name}.',
  'line.ok': 'OK',
  'line.clear': 'Effacer',

  'setup.title': 'Configurer cette cuisine',
  'setup.body':
    "Ce serveur est vide. Nommez votre cuisine et créez le premier compte administrateur. Vous ne verrez cette page qu'une fois.",
  'setup.kitchenName': 'Nom de la cuisine',
  'setup.kitchenPlaceholder': 'Le Lion d’Or',
  'setup.yourName': 'Votre nom',
  'setup.yourNamePlaceholder': 'Comme la brigade vous appelle',
  'setup.passwordHint': 'Au moins 12 caractères.',
  'setup.passwordShort': 'Encore moins de 12 caractères.',
  'setup.failed': 'La configuration a échoué. Consultez le journal du serveur.',
  'setup.create': 'Créer la cuisine',
  'setup.codeHint':
    'La configuration depuis l’extérieur du réseau de la cuisine demande ce code. C’est SETUP_TOKEN dans les réglages de Mise, ou la fin du lien affiché par le programme d’installation. Si aucun n’a été défini, Mise en a créé un et l’a écrit dans son journal.',
  'setup.codeLabel': 'Code de configuration',
  'setup.stepKitchen': 'Restaurant',
  'setup.stepYou': 'Vous',
  'setup.stepBrigade': 'Postes & équipe',
  'setup.stepRecipes': 'Recettes',
  'setup.stepSettings': 'Réglages',
  'setup.stepCheck': 'Vérification',
  'setup.stepOf': 'Étape {current} sur {total}',
  'setup.stepShort': 'Étape {current} / {total}',
  'setup.next': 'Suivant',
  'setup.back': 'Retour',
  'setup.skip': 'Passer pour l’instant',
  'setup.optional': 'Facultatif',
  'setup.required': 'Remplissez d’abord ce champ.',
  'setup.kitchenTitle': 'Nommez le restaurant',
  'setup.kitchenBody':
    'Ce nom figure en haut de chaque écran. La langue devient celle de la cuisine ; chacun peut toujours choisir la sienne.',
  'setup.youTitle': 'Votre compte',
  'setup.youBody':
    'Vous êtes l’administrateur. Vous vous connectez avec cet e-mail et ce mot de passe, depuis n’importe quel appareil.',
  'setup.emailInvalid': 'Cela ne ressemble pas à une adresse e-mail.',
  'setup.confirmPassword': 'Confirmer le mot de passe',
  'setup.showPassword': 'Afficher le mot de passe',
  'setup.passwordMismatch': 'Les deux mots de passe ne sont pas identiques.',
  'setup.passwordMatch': 'Les mots de passe correspondent.',
  'setup.brigadeTitle': 'Postes et équipe',
  'setup.brigadeBody':
    'Les postes organisent chaque liste de mise en place. Commencez par ceux que vous avez ; vous pourrez les renommer ou en ajouter plus tard.',
  'setup.stationsHeading': 'Postes',
  'setup.stationsEmpty': 'Ajoutez au moins un poste.',
  'setup.stationDuplicate': 'Deux postes portent le même nom.',
  'setup.staffHeading': 'Équipe',
  'setup.staffBody':
    'Les cuisiniers se connectent sur une tablette de cuisine en touchant leur nom et en saisissant leur code PIN. Les responsables pourront recevoir un e-mail et un mot de passe plus tard dans les Réglages.',
  'setup.staffEmpty':
    'Personne d’autre pour l’instant. Ajoutez votre brigade maintenant, ou plus tard dans les Réglages.',
  'setup.addPerson': 'Ajouter quelqu’un',
  'setup.nameMissing': 'Chaque ligne a besoin d’un nom.',
  'setup.pinInvalid': 'Un code PIN compte 4 à 8 chiffres.',
  'setup.yourPin': 'Votre code PIN (facultatif)',
  'setup.yourPinHint':
    'Pour vous connecter sur la tablette de la cuisine comme le reste de la brigade. Laissez vide pour passer ; vous pourrez en définir un plus tard.',
  'setup.summaryPin': 'Code PIN pour la tablette de la cuisine',
  'setup.backupsTitle': 'Sauvegardes',
  'setup.backupsHint':
    'Mise sauvegarde toute la cuisine chaque nuit. Une copie ailleurs évite qu’un disque mort ou un vol emporte aussi les sauvegardes. Vous pourrez changer cela plus tard dans les Réglages.',
  'setup.backupsTestFirst':
    'Testez d’abord la connexion au NAS, ou choisissez un autre endroit pour les sauvegardes.',
  'setup.backupsConnectFirst':
    'Connectez d’abord OneDrive, ou choisissez un autre endroit pour les sauvegardes.',
  'setup.codeForBackups':
    'Nécessaire pour tester le NAS ou connecter OneDrive depuis l’extérieur du réseau de la cuisine. C’est SETUP_TOKEN dans les réglages de Mise, ou le code que Mise a écrit dans son journal.',
  'setup.recipesTitle': 'Recettes',
  'setup.recipesBody':
    'Ajoutez au livre les plats et la mise en place que vous connaissez déjà : un nom et ce que donne une fournée. Ingrédients et méthode pourront suivre dans le livre de recettes.',
  'setup.recipesEmpty':
    'Pas encore de recettes. Vous pouvez passer cette étape et les ajouter plus tard dans le livre de recettes.',
  'setup.addRecipe': 'Ajouter une recette',
  'setup.recipeName': 'Nom de la recette',
  'setup.recipeType': 'Type',
  'setup.makes': 'Une fournée donne',
  'setup.recipeDuplicate': 'Deux recettes portent le même nom.',
  'setup.yieldInvalid': 'Une fournée doit donner plus de 0.',
  'setup.settingsTitle': 'Le fonctionnement de cette cuisine',
  'setup.settingsBody': 'Tout ceci peut être modifié plus tard dans les Réglages.',
  'setup.thisDevice': 'Cet appareil',
  'setup.enrolDevice': 'Utiliser cet appareil comme tablette de cuisine',
  'setup.enrolHint':
    'L’équipe pourra s’y connecter avec son code PIN. Laissez désactivé s’il s’agit de votre téléphone ou ordinateur personnel.',
  'setup.deviceName': 'Nom de la tablette',
  'setup.checkTitle': 'Vérifier et créer',
  'setup.checkBody':
    'Rien n’est enregistré avant d’appuyer sur créer. Revenez à une étape pour la modifier.',
  'setup.summaryNone': 'Aucun',
  'setup.summaryAdmin': '{name} · administrateur',
  'setup.summaryTablet': 'Enregistré comme « {name} »',
  'setup.summaryNoTablet': 'Pas une tablette de cuisine',
  'setup.defaultLarder': 'Garde-manger',
  'setup.defaultSauce': 'Sauces',
  'setup.defaultSaute': 'Sauté',
  'setup.defaultGrill': 'Grill',
  'setup.defaultPastry': 'Pâtisserie',
  'welcome.step0': 'Bienvenue',
  'welcome.eyebrow': "Serveur neuf · rien n'est encore configuré",
  'welcome.headline': 'Vos recettes et votre mise en place, sur votre propre serveur.',
  'welcome.lead1':
    'Ceci est un nouveau serveur Mise. Configurer la cuisine prend environ cinq minutes.',
  'welcome.lead2':
    "Rien n'est enregistré avant la dernière étape, et tout peut être modifié plus tard.",
  'welcome.f1t': 'Fiches techniques',
  'welcome.f1b':
    'Ajustez au rendement ou au nombre de couverts, construisez les plats à partir de sous-recettes, avec les allergènes de chaque sous-recette.',
  'welcome.f2t': 'Une liste de mise en place pour la cuisine',
  'welcome.f2b':
    'Les chefs y ajoutent ce qu’il faut préparer, par poste. Les lignes cochées disparaissent d’elles-mêmes deux heures plus tard.',
  'welcome.f3t': 'La brigade travaille sur tablette',
  'welcome.f3b':
    'Les cuisiniers saisissent un nom et un code, cochent la mise en place et prennent une tâche, pour que rien ne soit fait deux fois. Chaque écran se met à jour en direct.',
  'welcome.stepsLabel': 'Configuration · six étapes',
  'welcome.duration': 'Environ 5 minutes',
  'welcome.readyLabel': 'À portée de main',
  'welcome.r1': 'Le nom du restaurant',
  'welcome.r2': "Un e-mail et un mot de passe pour vous, l'administrateur",
  'welcome.r3': 'Vos postes — garde-manger, saucier, pâtisserie, passe',
  'welcome.r4':
    'Éventuellement votre équipe, un code de 4 à 8 chiffres chacun, et quelques recettes',
  'welcome.changeNote': "Passez ce que vous n'avez pas sous la main. Rien n'est définitif.",
  'welcome.selfHost':
    "Tout ce que vous saisissez reste sur ce serveur. Aucun compte n'est créé ailleurs, et Mise ne communique rien vers l'extérieur.",
  'welcome.cta': 'Configurer cette cuisine',
  'setup.readyLabel': 'Prêt',
  'setup.readyEyebrow': 'Configuration terminée',
  'setup.readyTitle': '{kitchen} est prête.',
  'setup.readyBody': 'Ouverture de la cuisine…',
  'tour.label': 'Visite',
  'tour.promptEyebrow': 'Bienvenue, {name}',
  'tour.promptTitle': 'Une visite rapide ?',
  'tour.promptBody':
    'Une minute : où se trouve votre liste de mise en place, comment cocher et prendre une tâche, et où sont les recettes.',
  'tour.promptNote': 'Cette question ne vous sera posée qu’une fois.',
  'tour.start': 'Faites-moi visiter',
  'tour.notNow': 'Pas maintenant',
  'tour.skip': 'Passer la visite',
  'tour.finish': 'Terminé',
  'tour.welcomeTitle': 'Voici {kitchen}',
  'tour.welcomeBody':
    'Mise réunit les recettes et la mise en place de la cuisine au même endroit, sur votre propre serveur. Voici où tout se trouve.',
  'tour.todayBody':
    'Tout ce qui doit être préparé aujourd’hui, par poste. C’est la page sur laquelle travaille la ligne.',
  'tour.stationsTitle': 'Votre poste',
  'tour.stationsBody': 'Limitez la liste à un poste, ou seulement aux tâches à votre nom.',
  'tour.tickTitle': 'Cocher',
  'tour.tickBody':
    'Touchez une ligne quand elle est faite. Elle passe en gris sur tous les écrans aussitôt.',
  'tour.makingBody':
    'Vous commencez quelque chose ? Touchez d’abord la petite coche, pour que personne d’autre ne prépare la même chose.',
  'tour.addLineTitle': 'Ajouter à la liste',
  'tour.addLineBody':
    'La mise en place s’ajoute à la main sur la liste continue. Ajoutez deux fois la même chose et les quantités s’additionnent sur une ligne.',
  'tour.recipesBody':
    'Toutes les recettes de la cuisine, avec leurs allergènes. Adaptez les quantités, ou imprimez-les pour le passe.',
  'tour.ingredientsBody': 'Ce dont les recettes sont faites, avec allergènes et pertes de parage.',
  'tour.settingsBody':
    'Postes, équipe et codes PIN, tablettes de cuisine, fiches plats et sauvegardes.',
  'tour.accountTitle': 'Votre langue',
  'tour.accountBody': 'Choisissez votre langue ici, et déconnectez-vous à la fin du service.',
  'tour.doneTitle': 'Fin de la visite',
  'tour.doneBody': 'Tout le reste se trouve dans la barre du haut.',

  'task.remove': 'Retirer {task} de la liste',
  'task.removeConfirm': 'Retirer ?',

  'addTask.what': 'À faire',
  'addTask.placeholder': 'Échalotes en brunoise',
  'addTask.submit': 'Ajouter la ligne',
  'addTask.fromBook': 'Du livre de recettes',
  'addTask.makes': 'donne {amount}',
  'addTask.linked': 'Liée à la recette {name}. Qui la prépare ouvre la recette à cette quantité.',
  'task.recipe': 'Recette',
  'task.openRecipe': 'Ouvrir la recette de {task}',

  'recipes.subtitle':
    'Mises en place et composants. « Sans » montre ce qu’une table allergique peut avoir, sous-recettes comprises. Les plats ont leur propre onglet.',
  'recipes.search': 'Chercher dans le livre',
  'recipes.sort': 'Type',
  'recipes.anySort': 'Tous les types',
  'recipes.prep': 'Préparations',
  'recipes.components': 'Éléments',
  'recipes.freeFrom': 'Sans…',
  'recipes.freeFromOption': 'Sans {allergen}',
  'recipes.clearFreeFrom': 'Ne plus filtrer par allergène',
  'recipes.colSortStation': 'Type · poste',
  'recipes.colMakes': 'Rendement',
  'recipes.noMatch': 'Rien dans le livre ne correspond.',
  'recipes.empty':
    'Le livre est vide. Commencez par un fond ou une sauce, puis les plats qui les utilisent.',
  'recipes.noStation': 'aucun poste',
  'recipes.noneInTree': 'Sans {allergen}, sous-recettes comprises',
  'recipes.portions_one': '{count} portion',
  'recipes.portions_other': '{count} portions',
  'recipes.countFreeFrom': '{shown} recettes sur {total} sans {allergen}',
  'recipes.countFiltered': '{shown} recettes sur {total}',
  'recipes.count_one': '{count} recette dans le livre',
  'recipes.count_other': '{count} recettes dans le livre',
  'recipes.new': 'Nouvelle recette',

  'recipe.back': '← Le livre',
  'recipe.backToBook': 'Retour au livre',
  'recipe.makes': 'Donne {amount}',
  'recipe.minutes': '{count} min',
  'recipe.keeps_one': 'Se garde {count} heure',
  'recipe.keeps_other': 'Se garde {count} heures',
  'recipe.asWritten': 'Telle qu’écrite',
  'recipe.scaled': '{factor}× la recette écrite',
  'recipe.contains': 'Contient',
  'recipe.nothingDeclarable': 'Rien à déclarer',
  'recipe.mayContain': 'Peut contenir : {allergens}.',
  'recipe.workedOut': 'Calculé à partir des ingrédients et de chaque sous-recette.',
  'recipe.empty': 'Cette recette est encore vide.',
  'recipe.method': 'Méthode',
  'recipe.storage': 'Conservation',
  'recipe.print': 'Imprimer la fiche recette',
  'recipe.duplicate': 'Dupliquer',
  'recipe.copyName': '{name} (copie)',
  'recipe.usedBy': 'Utilisée dans',
  'recipe.level': 'Niv',
  'recipe.what': 'Quoi',
  'recipe.open': 'ouvrir',

  'scale.ask': 'Demander une taille',
  'scale.portions': 'Portions',
  'scale.need': "J'ai besoin de",
  'scale.batches': 'Fournées',

  'plating.title': 'Le dressage',
  'plating.alt': "L'assiette telle qu'elle part",
  'plating.remove': 'Supprimer la photo',
  'plating.empty': "Pas encore de photo. L'assiette que le cuisinier reproduit va ici, de face.",
  'plating.uploading': 'Envoi…',
  'plating.add': 'Ajouter une photo de dressage',
  'plating.addAnother': 'Ajouter une autre photo',

  'print.whatGoesIn': 'Ce qui entre dedans',

  'editor.editing': 'Modification',
  'editor.name': 'Nom de la recette',
  'editor.namePlaceholder': 'Velouté de volaille',
  'editor.status': 'Statut',
  'editor.lastSaved': 'Enregistrée {time}',
  'editor.notSaved': 'Pas encore enregistrée',
  'editor.colSort': 'Type',
  'editor.colWhat': "Ce que c'est",
  'editor.colNote': 'Note',
  'editor.sectionHeading': 'Titre de section',
  'editor.removeHeading': 'Retirer le titre',
  'editor.newSection': 'Section {count}',
  'editor.notePlaceholder': 'finement ciselé',
  'editor.removeLine': 'Retirer la ligne',
  'editor.addLine': 'Ajouter une ligne',
  'editor.lines_one': '{count} ligne',
  'editor.lines_other': '{count} lignes',
  'editor.addSection': 'Ajouter une section',
  'editor.hintNext': 'ligne suivante',
  'editor.hintField': 'champ suivant',
  'editor.hintMove': 'déplacer une ligne',
  'editor.hintCreate': 'sur un nom inconnu le crée',
  'editor.kindRecipe': 'Recette',
  'editor.kindIngredient': 'Ingrédient',
  'editor.kindNew': 'Nouveau',
  'editor.theRest': 'Le reste',
  'editor.batchMakes': 'Une fournée donne',
  'editor.dishPlates_one': 'Les quantités sont pour une assiette.',
  'editor.dishPlates_other': 'Les quantités sont pour {count} assiettes.',
  'editor.yieldUnit': 'Unité de rendement',
  'editor.prepMinutes': 'Préparation, minutes',
  'editor.keepsHours': 'Conservation, heures',
  'editor.storagePlaceholder': 'Sous vide, chambre froide, étiqueté',
  'editor.tags': 'Étiquettes',
  'editor.tagsPlaceholder': 'tourte, à la carte',
  'editor.mayContain': 'Peut contenir · contamination croisée seulement',
  'editor.rolledUp': 'Additionné à partir des lignes',
  'editor.rollupUnsaved': 'Enregistrez pour calculer les allergènes.',
  'editor.rollupContains': 'Contient {allergens}',
  'editor.rollupNote': 'Au dernier enregistrement, sous-recettes comprises.',
  'editor.rollupNone': 'Rien à déclarer en dessous, au dernier enregistrement.',
  'editor.stepFirst': 'Faire suer les échalotes au beurre sans coloration',
  'editor.stepNext': "L'étape suivante",
  'editor.step': 'Étape {count}',
  'editor.removeStep': "Retirer l'étape {count}",

  'picker.label': "Ce qu'est cette ligne",
  'picker.placeholder': 'Ingrédient ou sous-recette',
  'picker.create': "Créer l'ingrédient",
  'picker.creating': 'Création',

  'ingredients.subtitle':
    'Le rendement après parage, la densité et le poids à la pièce permettent à la liste de dire combien sortir de la chambre froide. Vous pouvez aussi ajouter des ingrédients depuis l’éditeur de recettes.',
  'ingredients.search': 'Chercher des ingrédients',
  'ingredients.new': 'Nouvel ingrédient',
  'ingredients.colYield': 'Rendement',
  'ingredients.colDensity': 'g / ml',
  'ingredients.colEach': 'g pièce',
  'ingredients.noMatch': 'Aucun résultat.',
  'ingredients.empty': "Rien ici pour l'instant.",
  'ingredients.explainTitle': 'À quoi servent les trois chiffres',
  'ingredients.yieldTitle': 'Rendement.',
  'ingredients.yieldBody':
    'Ce qui reste après épluchage et parage, en part de ce qui est acheté : un kilo d’oignons donne environ 900 g utilisables.',
  'ingredients.densityTitle': 'Grammes par millilitre.',
  'ingredients.densityBody':
    "Permet à une recette écrite en litres de donner un poids, et inversement. L'huile, c'est environ 0,92.",
  'ingredients.eachTitle': 'Grammes la pièce.',
  'ingredients.eachBody':
    'Transforme un nombre en poids. Un oignon fait environ 170, un œuf environ 50.',
  'ingredients.byVolume': 'Mesuré au volume',
  'ingredients.counted': 'Compté',
  'ingredients.weighed': 'Pesé',
  'ingredients.category': 'Catégorie',
  'ingredients.categoryPlaceholder': 'Légume',
  'ingredients.measured': 'Mesuré habituellement',
  'ingredients.optWeight': 'Au poids',
  'ingredients.optVolume': 'Au volume',
  'ingredients.optCount': 'À la pièce',
  'ingredients.yieldLabel': 'Rendement, pour cent',
  'ingredients.yieldHint': 'Ce qui reste après épluchage et parage. Les oignons, environ 90.',
  'ingredients.densityLabel': 'Grammes par millilitre',
  'ingredients.densityHint': "Seulement pour passer du poids au volume. L'huile, environ 0,92.",
  'ingredients.eachLabel': 'Grammes la pièce',
  'ingredients.eachHint': 'Seulement pour passer du nombre au poids. Un œuf, environ 50.',
  'ingredients.allergens': 'Allergènes',

  'settings.cookOnly':
    "Seuls les chefs et les administrateurs peuvent modifier l'organisation de la cuisine.",
  'settings.tabStaff': 'Équipe',
  'settings.tabStations': 'Postes',
  'settings.tabDevices': 'Appareils',
  'settings.tabKitchen': 'Cuisine',

  'staff.loadError': "Impossible de charger la liste de l'équipe.",
  'staff.title': 'Équipe',
  'staff.add': 'Ajouter quelqu’un',
  'staff.you': '(vous)',
  'staff.pinTag': 'Code',
  'staff.passwordTag': 'Mot de passe',
  'staff.locked': 'Bloqué',
  'staff.namePlaceholder': 'Comme la brigade l’appelle',
  'staff.role': 'Rôle',
  'staff.station': 'Poste habituel',
  'staff.noStation': 'Pas de poste fixe',
  'staff.newPin': 'Nouveau code',
  'staff.keepIt': 'Laisser vide pour le garder',
  'staff.pinPlaceholder': '4 chiffres',
  'staff.pinHint': 'Pour se connecter sur une tablette de cuisine.',
  'staff.passwordSection': 'Connexion par mot de passe, pour les chefs et responsables',
  'staff.newPassword': 'Nouveau mot de passe',
  'staff.passwordPlaceholder': 'Au moins 12 caractères',
  'staff.addSubmit': 'Ajouter à la brigade',

  'stations.loading': 'Chargement des postes…',
  'stations.loadError': 'Impossible de charger les postes.',
  'stations.title': 'Postes',
  'stations.body':
    'Les listes sont groupées par poste et imprimées dans cet ordre, alors rangez-les comme la cuisine est organisée.',
  'stations.empty':
    "Pas encore de postes. Une cuisine en a besoin d'au moins un avant qu'une liste puisse être groupée.",
  'stations.addLabel': 'Ajouter un poste',
  'stations.placeholder': 'Garde-manger',
  'stations.rename': 'Renommer',
  'stations.moveEarlier': 'Avancer {name}',
  'stations.moveLater': 'Reculer {name}',

  'devices.title': 'Tablettes de cuisine',
  'devices.body':
    'Les cuisiniers ne peuvent se connecter par code que sur une tablette enregistrée. Enregistrez-la depuis la tablette elle-même, connecté en administrateur.',
  'devices.enrolled': 'Enregistrée le {date}',
  'devices.lastUsed': 'dernière utilisation le {date}',
  'devices.neverUsed': 'jamais utilisée',
  'devices.empty': 'Aucune tablette enregistrée, donc personne ne peut se connecter par code.',
  'devices.enrolLabel': "Enregistrer l'appareil que vous utilisez",
  'devices.placeholder': 'Tablette du passe',
  'devices.enrolling': 'Enregistrement…',
  'devices.enrol': 'Enregistrer cet appareil',
  'devices.enrolledOk':
    "Enregistré. Cet appareil peut maintenant afficher l'équipe et accepter les codes.",
  'devices.revokedTitle': 'Révoquées',
  'devices.revokedOn': 'révoquée le {date}',
  'devices.revoke': 'Révoquer',
  'devices.reallyRevoke': 'Vraiment révoquer ?',
  'devices.revokeTitle': 'Déconnecte immédiatement tout le monde de {name}',

  'kitchen.loadError': 'Impossible de charger les réglages de la cuisine.',
  'version.title': 'Version de Mise',
  'version.running': 'Cette cuisine utilise Mise {version}.',
  'version.upToDate': 'C’est la version la plus récente.',
  'version.newer': 'Mise {version} est sorti.',
  'version.whatChanged': 'Ce qui a changé',
  'version.checkFailed':
    'Impossible de joindre GitHub pour chercher une version plus récente. Mise réessaiera demain.',
  'version.notChecked':
    'Pas encore vérifié. Mise regarde une minute après son démarrage, puis une fois par jour.',
  'version.checkLabel': 'Chercher une version plus récente une fois par jour',
  'version.checkHint':
    'Mise demande à GitHub quelle version est la plus récente. Rien sur votre cuisine n’est envoyé.',
  'version.howTitle': 'Comment mettre à jour',
  'version.backupFirst':
    'Téléchargez d’abord une sauvegarde. La base de données se met à jour au démarrage de Mise.',
  'version.major':
    '{version} est une nouvelle version majeure. Lisez d’abord ce qui a changé, puis mettez MISE_VERSION à {major} dans .env, ou le tag de l’image à :{major} sur TrueNAS.',
  'version.howTrueNas': 'TrueNAS',
  'version.howTrueNasSteps':
    'Ouvrez Apps, choisissez l’app mise et cliquez sur Update ou Pull Images.',
  'version.howInstaller': 'Installé avec le programme d’installation',
  'version.howInstallerSteps':
    'Dans le dossier mise-kitchen, relancez la commande d’installation :',
  'version.howDocker': 'Docker seul',
  'version.howDockerSteps': 'Dans le dossier contenant compose.yaml, lancez :',
  'kitchen.title': 'Cette cuisine',
  'kitchen.units': 'Unités',
  'kitchen.metric': 'Métrique — grammes et litres',
  'kitchen.imperial': 'Impérial — onces et tasses américaines',
  'kitchen.unitsHint':
    'Les unités par défaut des nouvelles recettes. Les recettes existantes gardent celles dans lesquelles elles ont été écrites.',
  'kitchen.language': 'Langue',
  'kitchen.languageHint':
    "La langue de l'application pour ceux qui n'en ont pas choisi une. Les recettes restent exactement telles qu'elles ont été saisies.",
  'kitchen.retention': 'Lignes disparues de la liste continue',
  'kitchen.retentionKeep': 'Les garder dans la base de données, hors de vue',
  'kitchen.retentionDelete': "Les supprimer pour gagner de l'espace",
  'kitchen.retentionHint':
    'Les lignes gardées disent qui a fait quoi et quand, pour des rapports ultérieurs, et prennent de la place. Les lignes supprimées disparaissent pour de bon.',

  'handover.title': 'Passation',
  'handover.empty': 'Laisser un mot à l’équipe suivante',
  'handover.placeholder': 'Le poisson arrive en retard ; fond à lancer à 15 h.',
  'handover.save': 'Enregistrer le mot',
  'handover.clear': 'Effacer le mot',
  'handover.edit': 'Modifier',
  'handover.remove': 'Supprimer la note',
  'handover.removeConfirm': 'Supprimer ?',
  'handover.by': '{name}, {when}',
  'running.title': 'La liste',
  'running.subtitle':
    'Une seule liste pour toute la cuisine. Les lignes cochées disparaissent au bout de deux heures.',
  'running.empty': 'Rien sur la liste. Ajoutez ce qui est à faire.',
  'running.merged': 'Ajouté à la ligne {name} déjà sur la liste.',
  'running.goneAt': 'disparaît à {time}',

  'task.beingMade': 'En préparation',
  'task.beingMadeBy': 'Préparé par {name}',
  'settings.tabBackups': 'Sauvegardes',
  'backups.title': 'Sauvegardes',
  'backups.body':
    'Chaque nuit, Mise enregistre toute la cuisine, photos comprises, dans un seul fichier chiffré. Gardez aussi une copie ailleurs que sur cette machine.',
  'backups.lastGood': 'Dernière sauvegarde : {time}',
  'backups.never': 'Pas encore de sauvegarde. La première aura lieu d’ici quelques minutes.',
  'backups.failed': 'La dernière sauvegarde a échoué.',
  'backups.reason.bad_key':
    'Une clé de récupération compte 32 lettres et chiffres, par groupes de quatre.',
  'backups.reason.wrong_key':
    'Cette clé de récupération n’ouvre pas cette sauvegarde, ou le fichier est endommagé.',
  'backups.reason.not_a_backup': 'Ce fichier n’est pas une sauvegarde Mise.',
  'backups.reason.too_new':
    'Cette sauvegarde vient d’une version plus récente de Mise. Mettez d’abord ce serveur à jour.',
  'backups.reason.local':
    'Elle n’a pas pu être enregistrée sur cette machine. Le disque est peut-être plein.',
  'backups.reason.unreachable':
    'Mise n’a pas pu joindre le NAS. Vérifiez l’adresse et que le NAS est allumé.',
  'backups.reason.auth': 'Le NAS a refusé le nom d’utilisateur ou le mot de passe.',
  'backups.reason.folder': 'Ce dossier n’existe pas sur le NAS. Créez-le d’abord.',
  'backups.reason.remote': 'Le NAS a refusé d’enregistrer le fichier.',
  'backups.reason.unknown':
    'Un problème inattendu est survenu. Le journal du serveur donne les détails.',
  'backups.running': 'Sauvegarde en cours…',
  'backups.now': 'Sauvegarder maintenant',
  'backups.download': 'Télécharger',
  'backups.keyTitle': 'Clé de récupération',
  'backups.keyBody':
    'Une sauvegarde ne s’ouvre qu’avec cette clé. Imprimez-la ou notez-la, et gardez-la ailleurs qu’à côté de cette machine. Sans elle, personne ne peut ouvrir une sauvegarde.',
  'backups.keyShow': 'Afficher la clé de récupération',
  'backups.keyHide': 'Masquer',
  'backups.keyPrint': 'Imprimer',
  'backups.keyConfirm': 'Je l’ai notée',
  'backups.keyConfirmed': 'Marquée comme notée.',
  'backups.keyPrintTitle': 'Clé de récupération pour {kitchen}',
  'backups.keyPrintBody':
    'Cette clé permet de restaurer une sauvegarde de cette cuisine dans Mise. Ne la gardez pas près du serveur : plutôt au coffre du bureau ou chez vous.',
  'backups.whereTitle': 'Où vont les sauvegardes',
  'backups.onlyHereTitle': 'Les sauvegardes ne sont que sur cette machine',
  'backups.onlyHereBody':
    'Si elle tombe en panne, est volée ou si son disque lâche, les sauvegardes partent avec. Envoyez-les aussi vers un NAS ou OneDrive.',
  'backups.onlyHereAction': 'Choisir où elles vont',
  'backups.whereLocal': 'Sur cette machine, toujours',
  'backups.whereLocalHint':
    'Elles sont gardées sur la même machine que Mise. Si elle tombe en panne, est volée ou si son disque lâche, elles partent avec. Téléchargez-en donc une de temps en temps, ou envoyez-les vers un NAS ou OneDrive.',
  'backups.whereWebdav': 'Aussi vers un NAS ou Nextcloud',
  'backups.whereWebdavHint':
    'Par WebDAV, que proposent Synology, QNAP et Nextcloud. Une copie reste aussi sur cette machine.',
  'backups.webdavUrl': 'Adresse du dossier',
  'backups.webdavUrlHint':
    'L’adresse WebDAV d’un dossier qui existe déjà. Un simple http:// suffit à l’intérieur du restaurant.',
  'backups.webdavUser': 'Nom d’utilisateur',
  'backups.webdavPassword': 'Mot de passe',
  'backups.webdavPasswordKept': 'Laissez vide pour garder le mot de passe enregistré.',
  'backups.test': 'Tester la connexion',
  'backups.testing': 'Test en cours…',
  'backups.testOk': 'Connecté. Mise peut écrire dans ce dossier.',
  'backups.keepRemote': 'Garder sur le NAS',
  'backups.keepLocal': 'Garder sur cette machine',
  'backups.copies_one': '{count} sauvegarde',
  'backups.copies_other': '{count} sauvegardes',
  'backups.when': 'Sauvegarde de nuit à',
  'backups.zone': 'Fuseau horaire : {zone}.',
  'backups.kept': 'Sur cette machine',
  'backups.keptEmpty': 'Rien pour l’instant.',
  'backups.bannerFailed': 'La dernière sauvegarde a échoué.',
  'backups.bannerStale': 'Aucune sauvegarde depuis deux jours.',
  'backups.bannerKey':
    'Personne n’a encore noté la clé de récupération des sauvegardes. Sans elle, aucune sauvegarde ne s’ouvre.',
  'backups.bannerAction': 'Voir les sauvegardes',
  'backups.whereOnedrive': 'Aussi vers OneDrive',
  'backups.whereOnedriveHint':
    'Dans le dossier Apps/Mise de votre OneDrive. Mise ne voit rien d’autre dans votre OneDrive. Une copie reste aussi sur cette machine.',
  'backups.onedriveConnect': 'Connecter OneDrive',
  'backups.onedriveStarting': 'Demande à Microsoft…',
  'backups.onedriveCodeIntro':
    'Sur un téléphone ou un ordinateur, ouvrez cette page, saisissez le code ci-dessous et connectez-vous avec le compte Microsoft dont le OneDrive doit recevoir les sauvegardes.',
  'backups.onedriveWaiting': 'En attente de la connexion…',
  'backups.onedriveUnverified':
    'Microsoft indiquera que Mise n’est pas vérifiée. C’est normal pour une application indépendante, et Mise ne demande que son propre dossier.',
  'backups.onedriveConnected': 'Connecté au OneDrive de {account}.',
  'backups.onedriveDisconnect': 'Déconnecter',
  'backups.onedrive.declined': 'La connexion a été refusée chez Microsoft.',
  'backups.onedrive.expired': 'Le code a expiré avant la connexion. Recommencez.',
  'backups.onedrive.failed': 'Microsoft n’a pas accepté la connexion. Réessayez dans une minute.',
  'backups.keepOnedrive': 'Garder sur OneDrive',
  'backups.keepBoth': 'Garder sur le NAS et sur OneDrive',
  'backups.reason.onedrive_auth':
    'OneDrive n’accepte plus Mise. Reconnectez-le sur la page des sauvegardes.',
  'backups.reason.onedrive_full': 'OneDrive est plein.',
  'backups.reason.onedrive_unreachable':
    'Mise n’a pas pu joindre OneDrive. Vérifiez la connexion internet.',
  'backups.reason.onedrive_failed':
    'OneDrive a refusé la sauvegarde. Mise réessaiera dans quelques heures.',
  'restore.cta': 'Restaurer une sauvegarde',
  'restore.eyebrow': 'Restauration',
  'restore.title': 'Ramener une cuisine',
  'restore.body':
    'Choisissez un fichier de sauvegarde et saisissez la clé de récupération imprimée pour lui. Équipe, recettes, photos et listes de mise en place reviennent toutes. Chacun se reconnecte ensuite.',
  'restore.file': 'Fichier de sauvegarde',
  'restore.key': 'Clé de récupération',
  'restore.keyHint': 'Majuscules et tirets facultatifs.',
  'restore.fileMissing': 'Choisissez un fichier de sauvegarde.',
  'restore.keyMissing': 'Saisissez la clé de récupération.',
  'restore.submit': 'Restaurer',
  'restore.restoring': 'Restauration…',
  'restore.working': 'Sur une petite machine, cela peut prendre une minute.',
  'restore.done': '{kitchen} est de retour',
  'restore.doneBody':
    'Connectez-vous avec la même adresse e-mail et le même mot de passe qu’avant. Les sauvegardes restent sur cette machine jusqu’à ce que vous configuriez à nouveau un NAS dans les Réglages.',
  'restore.counts': 'Équipe : {staff} · Recettes : {recipes} · Photos : {photos}',
  'restore.signIn': 'Se connecter',
  'restore.asideTitle': 'Ce qui revient',
  'restore.asideStaff': 'L’équipe, avec mots de passe et codes PIN',
  'restore.asideRecipes': 'Recettes, ingrédients et photos de dressage',
  'restore.asidePrep': 'La liste de mise en place',
  'restore.asideTablets': 'Les tablettes enregistrées, si le serveur garde son adresse',

  // Dish cards
  'recipe.dishCard': 'Fiche plat',
  'editor.frontOfHouse': 'Salle',
  'editor.frontOfHouseHint': 'Ce que la fiche plat dit à la salle.',
  'editor.flavour': 'Profil de saveur',
  'editor.flavourPlaceholder': 'crémeux, ail, frais',
  'editor.temperature': 'Servi',
  'editor.course': 'Place dans le menu',
  'editor.drinks': 'Accords boissons',
  'editor.drinksPlaceholder': 'Bordeaux blanc, kombucha',
  'editor.cutlery': 'Couverts',
  'editor.cutleryPlaceholder': 'petite cuillère',
  'editor.listHint': 'Séparez par des virgules.',
  'editor.notSet': 'Non renseigné',
  'temperature.cold': 'Froid',
  'temperature.room': 'Température ambiante',
  'temperature.warm': 'Tiède',
  'temperature.hot': 'Chaud',
  'temperature.hot_and_cold': 'Chaud et froid',
  'course.amuse': 'Amuse-bouche',
  'course.starter': 'Entrée',
  'course.middle': 'Plat intermédiaire',
  'course.main': 'Plat principal',
  'course.pre_dessert': 'Pré-dessert',
  'course.dessert': 'Dessert',
  'course.mignardise': 'Mignardises',
  'course.side': 'Accompagnement',
  'ingredients.vegan': 'Végan',
  'ingredients.veganYes': 'Oui',
  'ingredients.veganNo': 'Non',
  'ingredients.veganUnknown': 'Non précisé',
  'ingredients.veganHint':
    'Une fiche plat ne dit jamais qu’un plat est végan tant qu’un de ses ingrédients n’est pas précisé.',
  'ingredients.whichCereals': 'Quelles céréales',
  'ingredients.whichNuts': 'Quels fruits à coque',
  'ingredients.cerealsPlaceholder': 'blé, seigle',
  'ingredients.nutsPlaceholder': 'noisette, noix',
  'ingredients.detailsHint':
    'La loi demande que la céréale et le fruit à coque soient nommés sur une fiche plat.',
  'card.title': 'Fiche plat',
  'card.back': '← Le plat',
  'card.language': 'Langue de la fiche',
  'card.theme': 'Apparence',
  'card.themeDay': 'Jour',
  'card.themeNight': 'Nuit',
  'card.print': 'Imprimer',
  'card.download': 'Télécharger le PDF',
  'card.downloading': 'Création du PDF…',
  'card.downloadFailed': 'Le PDF n’a pas pu être créé. Réessayez, ou imprimez.',
  'card.notADish': 'Seul un plat a une fiche plat.',
  'card.unavailable':
    'Ce plat renvoie à une recette ou un ingrédient qui n’existe plus, ses allergènes ne peuvent donc pas être établis. Corrigez d’abord la recette.',
  'card.noAccess':
    'Dans cette cuisine, seuls les chefs et les administrateurs peuvent ouvrir les fiches plats.',
  'card.attentionTitle': 'À vérifier avant d’imprimer',
  'card.attentionVegan':
    'Personne n’a précisé si ceux-ci sont végans : {names}. Tant que ce n’est pas fait, la fiche ne peut pas dire que le plat est végan.',
  'card.attentionDetails':
    'Ceux-ci contiennent du gluten ou des fruits à coque sans dire lesquels : {names}.',
  'card.attentionPhoto': 'Ce plat n’a pas encore de photo.',
  'card.attentionDraft': 'Cette recette est encore un brouillon.',
  'card.fixIngredients': 'Ouvrir les ingrédients',
  'card.menu': 'Menu',
  'card.flavour': 'Profil de saveur',
  'card.temperature': 'Température',
  'card.course': 'Place dans le menu',
  'card.components': 'Composants',
  'card.drinks': 'Accords boissons',
  'card.cutlery': 'Couverts',
  'card.allergens': 'Allergènes',
  'card.component': 'Composant',
  'card.vegan': 'Végan',
  'card.other': 'Autres ingrédients du plat',
  'card.keyContains': 'contient',
  'card.keyMayContain': 'peut contenir des traces',
  'card.keyVegan': 'végan',
  'card.keyUnknown': 'non renseigné',
  'card.cerealsAndNuts': 'Céréales contenant du gluten et fruits à coque',
  'card.noCerealsOrNuts': 'Aucune céréale contenant du gluten ni fruit à coque dans ce plat.',
  'card.cereals': 'Céréales : {names}',
  'card.nuts': 'Fruits à coque : {names}',
  'card.unnamed': 'pas encore nommé',
  'card.printed': 'Imprimé le {date}',
  'card.page': 'Page {page} sur {pages}',
  'card.madeWithMise': 'Fait avec Mise, logiciel libre sous licence AGPL-3.0',
  'card.noAllergens': 'Aucun des 14 allergènes',
  'card.notVegan': 'Non végan',
  'card.veganUnknown': 'Végan : non renseigné',
  'cardAllergen.eggs': 'Œuf',
  'cardAllergen.gluten': 'Gluten',
  'cardAllergen.lupin': 'Lupin',
  'cardAllergen.milk': 'Lait',
  'cardAllergen.mustard': 'Mou\u00adtarde',
  'cardAllergen.sulphites': 'Sul\u00adfites',
  'cardAllergen.molluscs': 'Mol\u00adlusques',
  'cardAllergen.fish': 'Pois\u00adson',
  'cardAllergen.soybeans': 'Soja',
  'cardAllergen.sesame': 'Sésame',
  'cardAllergen.celery': 'Céleri',
  'cardAllergen.crustaceans': 'Crus\u00adtacés',
  'cardAllergen.peanuts': 'Ara\u00adchides',
  'cardAllergen.nuts': 'Fruits à coque',
  'settings.tabDishCards': 'Fiches plats',
  'dishCards.intro':
    'L’apparence de chaque fiche plat de cette cuisine. Ouvrez une fiche depuis n’importe quel plat.',
  'dishCards.managersOnly':
    'Seuls les chefs et les administrateurs peuvent modifier l’apparence des fiches plats.',
  'dishCards.titleLabel': 'En-tête',
  'dishCards.titleHint': 'Laissez vide pour « {default} ».',
  'dishCards.locationName': 'Nom du lieu',
  'dishCards.address': 'Adresse',
  'dishCards.logo': 'Logo',
  'dishCards.logoHint': 'JPEG, PNG ou WebP, jusqu’à 2 Mo. Un carré convient le mieux.',
  'dishCards.logoUpload': 'Choisir un logo',
  'dishCards.logoReplace': 'Remplacer',
  'dishCards.logoRemove': 'Retirer',
  'dishCards.logoNone': 'Pas encore de logo.',
  'dishCards.warning': 'Avertissement en bas de chaque fiche',
  'dishCards.warningHint':
    'Écrivez-le dans chaque langue d’impression. Une fiche dans une langue sans avertissement reprend celui de la langue de la cuisine.',
  'dishCards.warningPlaceholder': 'Cette fiche plat est la propriété de …',
  'dishCards.show': 'Sur la fiche',
  'dishCards.part.menu': 'Menu',
  'dishCards.part.flavour': 'Profil de saveur',
  'dishCards.part.temperature': 'Température',
  'dishCards.part.course': 'Place dans le menu',
  'dishCards.part.drinks': 'Accords boissons',
  'dishCards.part.cutlery': 'Couverts',
  'dishCards.part.photo': 'Photo',
  'dishCards.part.logo': 'Logo',
  'dishCards.part.location': 'Lieu et adresse',
  'dishCards.part.summary': 'Allergènes au recto',
  'dishCards.part.mayContain': 'Mentions « peut contenir »',
  'dishCards.part.vegan': 'Colonne végan',
  'dishCards.theme': 'Apparence',
  'dishCards.themeDayHint': 'Blanc, économe en encre.',
  'dishCards.themeNightHint': 'Sombre, idéal à l’écran ou sur une laser couleur.',
  'dishCards.access': 'Qui peut ouvrir les fiches plats',
  'dishCards.accessEveryone': 'Toute personne connectée',
  'dishCards.accessManagers': 'Chefs et administrateurs seulement',
  'dishCards.miseLine':
    'Chaque fiche se termine par une petite ligne indiquant qu’elle a été faite avec Mise.',
  // Menus
  'nav.menus': 'Menus',
  'dishes.subtitle':
    'Chaque plat sous forme de fiche : ce que lit la salle, avec les allergènes calculés à partir de chaque sous-recette.',
  'dishes.new': 'Nouveau plat',
  'dishes.search': 'Chercher un plat',
  'dishes.anyCourse': 'Tous les services',
  'dishes.onMenu': 'Seulement sur un menu actif',
  'dishes.noMatch': 'Aucun plat ne correspond.',
  'dishes.empty':
    'Pas encore de plats. Un plat est ce qui part au passe : ajoutez-en un et il apparaît ici sous forme de fiche.',
  'dishes.count_one': '{count} plat',
  'dishes.count_other': '{count} plats',
  'dishes.countFreeFrom': '{shown} plats sur {total} sans {allergen}',
  'dishes.countFiltered': '{shown} plats sur {total}',
  'dishes.notOnMenu': 'Sur aucun menu',
  'dishes.broken':
    'Les allergènes ne peuvent pas être calculés : une sous-recette manque ou s’utilise elle-même.',
  'dishes.openSpec': 'Recette',
  'dishes.print': 'Imprimer ou PDF',
  'dishes.kept':
    'Cette cuisine réserve les fiches plats aux chefs et administrateurs. La recette vous reste ouverte.',
  'menus.subtitle':
    'Les plats que la salle vend ensemble. Imprimez la vue d’ensemble des allergènes d’un menu, ou toutes ses fiches plats d’un coup.',
  'menus.name': 'Nom du menu',
  'menus.namePlaceholder': 'Menu d’automne 2026',
  'menus.new': 'Nouveau menu',
  'menus.empty': 'Pas encore de menu. Commencez-en un avec un nom ci-dessus.',
  'menus.dishes_one': '{count} plat',
  'menus.dishes_other': '{count} plats',
  'menuStatus.draft': 'Brouillon',
  'menuStatus.active': 'Actif',
  'menuStatus.archived': 'Archivé',
  'menus.back': '← Menus',
  'menus.dishesTitle': 'Au menu',
  'menus.changedCount_one': '{count} modifié depuis l’impression des fiches',
  'menus.changedCount_other': '{count} modifiés depuis l’impression des fiches',
  'menus.noDishes': 'Pas encore de plat sur ce menu.',
  'menus.noCourse': 'Sans service',
  'menus.changed': 'Modifié',
  'menus.removeDish': 'Retirer {name} du menu',
  'menus.addDish': 'Ajouter le plat',
  'menus.pickDish': 'Choisir un plat',
  'menus.allDishesOn': 'Tous les plats sont déjà sur ce menu.',
  'menus.status': 'Statut',
  'menus.description': 'Description',
  'menus.descriptionPlaceholder': 'Quelques mots pour la salle, comme le prix ou les dates.',
  'menus.overview': 'Allergènes du menu',
  'menus.cardsTitle': 'Fiches plats',
  'menus.cardsProgress': 'Fiche {done} sur {total}…',
  'menus.allCards': 'Toutes les fiches plats (PDF)',
  'menus.lastPrinted': 'Fiches téléchargées pour la dernière fois le {when}.',
  'menus.neverPrinted': 'Les fiches plats de ce menu n’ont pas encore été téléchargées.',
  'menus.copyName': 'Nom de la copie',
  'menus.copyPlaceholder': '{name} (copie)',
  'menus.duplicate': 'Copier le menu',
  'menus.delete': 'Supprimer le menu',
  'menus.backToMenu': '← Le menu',
  'menus.overviewTitle': 'Allergènes du menu',
  'menus.dish': 'Plat',
  'access.eyebrow': 'Hors de la cuisine',
  'access.title': 'Demander l’accès',
  'access.body':
    'Hors de la cuisine, Mise ne s’ouvre que sur les appareils approuvés par la cuisine. Donnez un nom à cet appareil et demandez l’accès. Un chef ou l’administrateur l’approuve dans Réglages → Appareils.',
  'access.nameLabel': 'Nom de cet appareil',
  'access.namePlaceholder': 'ex. Téléphone de Sam',
  'access.ask': 'Demander l’accès',
  'access.asking': 'Demande…',
  'access.waitingTitle': 'En attente d’approbation',
  'access.waitingBody':
    '« {name} » a demandé l’accès. Demandez à un chef ou à l’administrateur de l’approuver dans Réglages → Appareils, et lisez-lui ce code pour qu’il sache que c’est vous :',
  'access.codeLabel': 'Code',
  'access.checking': 'Cette page ouvre Mise d’elle-même dès l’approbation.',
  'access.whyTitle': 'Pourquoi demander ?',
  'access.whyBody':
    'Recettes, équipe et allergènes appartiennent à la cuisine. Demander d’abord signifie que personne sur internet ne peut même atteindre la page de connexion. L’approbation dure jusqu’à son retrait, ou jusqu’à 90 jours sans utilisation de cet appareil.',
  'outside.title': 'Hors de la cuisine',
  'outside.body':
    'Téléphones et ordinateurs hors du réseau de la cuisine ou du VPN. Ils n’atteignent qu’une page de demande tant que personne ne les approuve ici. L’approbation dure jusqu’à son retrait, ou jusqu’à 90 jours sans utilisation.',
  'outside.waiting': 'En attente d’approbation',
  'outside.approved': 'Approuvés',
  'outside.empty':
    'Aucun appareil extérieur. Quelqu’un qui ouvre Mise hors de la cuisine peut demander l’accès ; sa demande apparaît ici.',
  'outside.code': 'Code',
  'outside.checkCode': 'N’approuvez que si la personne qui demande voit ce même code à l’écran.',
  'outside.passwordLabel': 'Votre mot de passe',
  'outside.passwordWhy': 'Vous êtes hors de la cuisine : approuver redemande votre mot de passe.',
  'outside.approve': 'Approuver',
  'outside.deny': 'Refuser',
  'outside.approvedBy': 'approuvé par {name} le {date}',
  'outside.approvedByFrom': 'approuvé par {name} depuis {device} le {date}',
  'outside.approvedOn': 'approuvé le {date}',
  'outside.thisDevice': 'Cet appareil',
  'outside.revokeSelf': 'Cet appareil devra redemander l’accès',
  'outside.reallyRevokeSelf': 'Bloquer cet appareil ?',
  'error.accessRequired': 'Cet appareil n’est pas approuvé pour l’accès hors de la cuisine.',
  'error.wrongPassword': 'Ce mot de passe n’est pas le bon.',
  'error.passwordNeeded':
    'Approuver depuis l’extérieur demande un mot de passe, et ce compte n’en a pas. Approuvez depuis la cuisine.',
  'error.tooManyRequests': 'Trop d’appareils attendent une approbation. Réessayez plus tard.',
  'settings.tabConnection': 'Connexion',
  'connection.relayedTitle': 'Mise ne peut pas savoir qui est dans la cuisine',
  'connection.relayedBody':
    'Certains visiteurs atteignent Mise par le relais de Docker ({address}), qui cache d’où ils viennent vraiment. Mise les compte donc comme extérieurs : chaque appareil demande l’accès une fois, et un chef l’approuve.',
  'connection.relayedTrusted':
    'Certains visiteurs atteignent Mise par le relais de Docker ({address}), qui cache d’où ils viennent vraiment. Vous avez choisi de les compter comme étant dans la cuisine : ils échappent à l’approbation exigée des appareils extérieurs, où qu’ils soient.',
  'connection.relayedTrust': 'Compter ces visiteurs comme étant dans la cuisine',
  'connection.relayedTrustHint':
    'Seulement si Mise n’est pas joignable depuis Internet, ou seulement par un serveur web de confiance. Sinon, quiconque le trouve échappe à l’approbation.',
  'connection.relayedFix':
    'Cela arrive avec Docker sans root, Podman, Docker Desktop, ou en IPv6 quand le réseau de Docker n’en a pas. Lancez Mise avec le réseau de l’hôte (network_mode: host), ou activez l’IPv6 pour le réseau de Docker, afin que Mise voie l’adresse de chaque visiteur. Voir « From outside the kitchen » dans le README.',
  'connection.domainTitle': 'Adresse depuis l’extérieur',
  'connection.domainBody':
    'Si Mise est accessible par internet, saisissez l’adresse qui y mène, comme mise.votrecuisine.fr. Depuis l’extérieur, Mise ne répond alors que sur cette adresse : l’IP seule, ou le nom d’un autre site sur le même serveur, ne trouve rien. Sur le réseau de la cuisine et le VPN, toutes les adresses continuent de fonctionner.',
  'connection.domainLabel': 'Domaine',
  'connection.domainSet': 'Depuis l’extérieur, Mise ne répond que sur {domain}.',
  'connection.domainUnset':
    'Non défini : depuis l’extérieur, toute adresse qui atteint ce serveur mène à Mise.',
  'connection.domainClear': 'Effacer',
  'connection.domainUseCurrent': 'Utiliser {domain}, l’adresse actuelle',
  'connection.domainShared':
    'D’autres sites sur la même IP publique ? Ce qui les sert déjà (Apache, LiteSpeed ou Nginx, souvent configuré via un panneau comme cPanel ou Plesk) doit transmettre ce domaine à Mise, en conservant le nom de domaine dans la requête. Si Mise tourne sur une autre connexion que ces sites, rien de plus n’est nécessaire.',
  'error.domainLocksYouOut':
    'Vous êtes connecté par une autre adresse : vous vous bloqueriez. Réglez-la depuis la cuisine, ou ouvrez d’abord Mise par la nouvelle adresse.',
  'proxy.title': 'Derrière un autre serveur web',
  'proxy.body':
    'Un autre serveur web de votre réseau (Apache, par exemple, avec vos sites) répond déjà pour vos domaines ? Laissez-le transmettre votre domaine Mise, avec son propre certificat. Mise doit alors savoir de quelle machine il s’agit, pour distinguer qui est sur place et qui est à l’extérieur.',
  'proxy.trusted': 'Mise croit {address} sur l’identité de chaque visiteur.',
  'proxy.none':
    'Aucun serveur web approuvé : tout ce qui passe par une autre machine compte comme extérieur.',
  'proxy.stop': 'Ne plus faire confiance',
  'proxy.seen': 'Les requêtes pour {host} arrivent par {address}. Est-ce votre serveur web ?',
  'proxy.trust': 'Faire confiance à {address}',
  'proxy.addressLabel': 'Ou saisissez l’adresse du serveur web',
  'proxy.trustTyped': 'Faire confiance',
  'proxy.apacheTitle': 'Configurer Apache',
  'proxy.miseAddress': 'Mise sur votre réseau',
  'proxy.step1':
    'Sur la machine Apache, vérifiez qu’elle atteint Mise. Ceci doit afficher « ok » :',
  'proxy.step1Bridge':
    'Apache dans une VM sur le même TrueNAS que Mise, et rien ne revient ? Les VM TrueNAS n’atteignent souvent pas leur propre hôte. Créez un pont (br0) dans Network sur TrueNAS, placez-y l’adresse de l’hôte et reliez la carte réseau de la VM à br0.',
  'proxy.step2': 'Enregistrez ceci sous /etc/apache2/sites-available/mise.conf :',
  'proxy.step3': 'Activez-le et obtenez son certificat, comme pour vos autres sites :',
  'proxy.step4':
    'Ouvrez https://{domain} une fois, puis revenez ici : Mise affiche l’adresse par laquelle c’est arrivé, et vous lui faites confiance.',
  'proxy.router':
    'Rien ne change sur votre routeur : les ports 80 et 443 vont déjà vers Apache. Faites pointer le domaine vers votre IP, comme vos autres sites.',
  'proxy.copy': 'Copier',
  'proxy.copied': 'Copié',
  'error.proxyNotLocal':
    'Utilisez l’adresse d’un serveur web du réseau de la cuisine, comme 192.168.1.60.',
  'https.title': 'HTTPS',
  'https.body':
    'Le HTTP simple continue de fonctionner. Le HTTPS permet aux tablettes de travailler hors ligne et d’installer Mise comme une app, et il est indispensable pour tout ce qui est accessible depuis internet.',
  'https.on': 'Activé',
  'https.off': 'Désactivé',
  'https.kitchenTitle': 'Sur le réseau de la cuisine',
  'https.kitchenBody':
    'Mise crée son propre certificat pour les adresses qu’utilisent vos tablettes. Aucun domaine ni internet nécessaire. Chaque tablette lui fait confiance une fois, depuis la page de confiance.',
  'https.renews': 'Se renouvelle tout seul. L’actuel est valable jusqu’au {date}.',
  'https.trustEachTablet': 'Sur chaque tablette, ouvrez cette page une fois et suivez les étapes :',
  'https.namesLabel': 'Adresses utilisées par les tablettes',
  'https.namesHint':
    'L’adresse dans la barre d’adresse des tablettes, sans http:// ni port. Plusieurs ? Séparez-les par des virgules.',
  'https.making': 'Création…',
  'https.turnOn': 'Activer',
  'https.turnOff': 'Désactiver',
  'https.updateNames': 'Mettre à jour les adresses',
  'https.portNote':
    'Le HTTPS répond sur le port {port}. Sur TrueNAS, l’app doit aussi publier ce port.',
  'https.domainTitle': 'Pour votre domaine',
  'https.domainTitleFor': 'Pour {domain}',
  'https.domainBody':
    'Un certificat gratuit de Let’s Encrypt, reconnu par tous les navigateurs sans rien faire sur l’appareil. Mise l’obtient et le renouvelle tout seul.',
  'https.domainNeedsAddress': 'Définissez d’abord l’adresse depuis l’extérieur ci-dessus.',
  'https.domainBehindProxy':
    'Mise est derrière votre propre serveur web, qui gère le HTTPS pour ce domaine. Vous n’en avez pas besoin.',
  'https.domainStep1': '{domain} pointe vers votre adresse IP publique.',
  'https.domainStep2':
    'Votre routeur redirige le port 80 vers le port {http} de Mise, et le 443 vers le port {https}. Sur un serveur cloud, l’installation s’en charge.',
  'https.domainStep3': 'Puis demandez le certificat :',
  'https.getCertificate': 'Obtenir le certificat',
  'https.asking': 'Demande à Let’s Encrypt…',
  'https.askingNote': 'Cela prend en général quelques secondes, deux minutes au plus.',
  'https.failedHint':
    'Le plus souvent, le port 80 n’atteint pas encore Mise, ou le domaine ne pointe pas encore ici. Let’s Encrypt n’autorise que quelques échecs par heure.',
  'https.renewFailed': 'Le dernier renouvellement a échoué ; Mise réessaiera : {reason}',
  'trust.eyebrow': 'Cet appareil',
  'trust.title': 'Faire confiance au certificat de la cuisine',
  'trust.body':
    'Une fois par appareil. Ensuite Mise s’ouvre ici en HTTPS, continue de fonctionner quand le réseau tombe et peut être installé comme une app.',
  'trust.notOn':
    'Le HTTPS n’est pas encore activé. Un administrateur l’active dans Réglages → Connexion.',
  'trust.trusted': 'Cet appareil lui fait confiance',
  'trust.trustedBody': 'Vous êtes sur Mise en HTTPS. Utilisez désormais cette adresse.',
  'trust.openMise': 'Ouvrir Mise',
  'trust.system.ios': 'iPad / iPhone',
  'trust.system.android': 'Android',
  'trust.system.windows': 'Windows',
  'trust.system.mac': 'Mac',
  'trust.system.other': 'Autre',
  'trust.download': 'Téléchargez le certificat de la cuisine.',
  'trust.downloadIos':
    'Dans Safari, téléchargez le certificat et autorisez-le quand un profil de configuration est proposé.',
  'trust.downloadButton': 'Télécharger le certificat',
  'trust.ios1':
    'Ouvrez Réglages, touchez « Profil téléchargé » en haut, puis Installer, et saisissez votre code.',
  'trust.ios2': 'Allez dans Réglages → Général → Informations → Réglages des certificats.',
  'trust.ios3': 'Activez la confiance totale pour « Mise ».',
  'trust.android1':
    'Ouvrez Paramètres et cherchez « certificat CA » (souvent dans Sécurité → Chiffrement et identifiants → Installer un certificat).',
  'trust.android2':
    'Choisissez « Certificat CA », touchez « Installer quand même » et sélectionnez mise-kitchen.crt dans vos téléchargements.',
  'trust.windows1':
    'Ouvrez le fichier téléchargé, choisissez « Installer le certificat », puis « Utilisateur actuel ».',
  'trust.windows2':
    'Choisissez « Placer tous les certificats dans le magasin suivant », sélectionnez « Autorités de certification racines de confiance », terminez et redémarrez le navigateur.',
  'trust.mac1':
    'Ouvrez le fichier téléchargé. Trousseaux d’accès l’ajoute à votre trousseau de session.',
  'trust.mac2':
    'Double-cliquez sur « Mise », ouvrez Se fier, et réglez « Lors de l’utilisation de ce certificat » sur « Toujours approuver ».',
  'trust.other1':
    'Ajoutez le fichier aux autorités de certification de confiance du système ou du navigateur. Firefox a sa propre liste : Paramètres → Vie privée et sécurité → Certificats → Autorités → Importer.',
  'trust.check':
    'Vérifiez : ceci ouvre cette page en HTTPS. Un avertissement signifie qu’une étape a été oubliée.',
  'trust.checkButton': 'Vérifier',
  'trust.fingerprint': 'Empreinte, pour comparer',
  'error.badName':
    'Ce n’est pas une adresse ni un nom d’hôte. Utilisez par exemple 192.168.1.50 ou mise.local.',
  'error.noDomain': 'Définissez d’abord l’adresse depuis l’extérieur.',
  'offline.title': 'Hors ligne.',
  'offline.body':
    'Mise est injoignable depuis {time}. Vous voyez ce que cet appareil avait, et les modifications sont gardées ici jusqu’à ce que Mise réponde.',
  'offline.waiting_one': '1 modification en attente.',
  'offline.waiting_other': '{count} modifications en attente.',
  'offline.sending_one': 'Envoi d’1 modification faite hors ligne…',
  'offline.sending_other': 'Envoi de {count} modifications faites hors ligne…',
  'offline.dropped': '{what} n’a pas pu être enregistré : {reason}',
  'offline.setAside':
    '{what} n’a pas pu être enregistré : Mise a rencontré un problème. Les autres modifications continuent.',
  'offline.tryAgain': 'Réessayer',
  'offline.letGo': 'Abandonner',
  'offline.lineWaiting': 'En attente d’envoi',
  'offline.allergensOnceSent': 'Les allergènes seront mis à jour dès l’envoi de vos modifications.',
  'offline.cardOnceSent': 'Cette fiche sera mise à jour dès l’envoi de vos modifications.',
  'offline.menuOnceSent':
    'Les allergènes et les fiches plat seront mis à jour dès l’envoi de vos modifications.',
  'offline.conflictTitle': 'Modifié sur un autre appareil',
  'offline.conflictBody':
    'Pendant que vous étiez hors ligne, quelqu’un a modifié {what}. Quelle version garder ?',
  'offline.yours': 'La vôtre',
  'offline.theirs': 'Actuellement dans Mise',
  'offline.keepMine': 'Garder la mienne',
  'offline.keepTheirs': 'Garder celle de Mise',
  'offline.items_one': '1 élément',
  'offline.items_other': '{count} éléments',
  'offline.field.note': 'Note',
  'offline.field.notes': 'Notes',
  'offline.field.method': 'Méthode',
  'offline.field.description': 'Description',
  'offline.field.tags': 'Étiquettes',
  'offline.field.components': 'Composants',
  'offline.field.dishes': 'Plats',
  'offline.field.type': 'Type de recette',
  'offline.field.yield': 'Rendement',
  'offline.field.portions': 'Portions',
  'offline.field.prepMinutes': 'Temps de préparation',
  'offline.field.cookMinutes': 'Temps de cuisson',
  'offline.field.keeps': 'Se conserve',
  'offline.field.allergens': 'Allergènes',
  'offline.field.mayContain': 'Peut contenir',
  'offline.yes': 'Oui',
  'offline.no': 'Non',
  'offline.unknownStation': 'Un poste supprimé depuis',
  'offline.label.note': 'la note de relève',
  'offline.label.addLine': 'la ligne de mise en place « {name} »',
  'offline.label.editLine': 'une modification de ligne de mise en place',
  'offline.label.removeLine': 'la suppression d’une ligne',
  'offline.label.recipe': 'la recette « {name} »',
  'offline.label.menu': 'le menu « {name} »',
  'offline.label.ingredient': 'l’ingrédient « {name} »',
  'error.offline':
    'Mise est injoignable pour l’instant, et ceci a besoin de la connexion. Réessayez quand elle sera revenue.',
  'prepPrint.print': 'Imprimer',
  'prepPrint.title': 'Mise en place',
  'prepPrint.empty': 'Rien sur la liste.',
  'prepPrint.line': '{name}, {amount}',
  'recipeCard.makes': 'Rendement',
  'recipeCard.prepTime': 'Préparation',
  'recipeCard.keeps': 'Se conserve',
  'recipeCard.days_one': '{count} jour',
  'recipeCard.days_other': '{count} jours',
  'recipeCard.hours_one': '{count} heure',
  'recipeCard.hours_other': '{count} heures',
  'recipeCard.mayContain': 'Peut contenir : {allergens}',
  'recipeCard.onThePlate': 'Dans l’assiette',
  'recipeCard.plating': 'Dressage',
  'recipeCard.ownRecipe': 'sa propre recette',
  'updated.title': 'Mise a été mis à jour',
  'updated.body':
    'Mise a été mis à jour. Rechargez pour utiliser la nouvelle version ; rien de ce qui attend d’être envoyé n’est perdu.',
  'updated.bodyVersion':
    'Mise est passé à la version {version}. Rechargez pour l’utiliser ; rien de ce qui attend d’être envoyé n’est perdu.',
  'updated.reload': 'Recharger',
  'error.pageTitle': 'Cette page ne s’est pas ouverte',
  'error.pageBody':
    'Une erreur s’est produite à l’ouverture. Recharger règle généralement le problème.',
  'access.waitingOne': '« {name} » demande l’accès depuis l’extérieur de la cuisine.',
  'access.waitingCount_one': '1 appareil demande l’accès depuis l’extérieur de la cuisine.',
  'access.waitingCount_other':
    '{count} appareils demandent l’accès depuis l’extérieur de la cuisine.',
  'access.checkCode': 'Vérifier le code et approuver',
  'error.incompatibleUnits':
    '{child} donne des {makes}, on ne peut donc pas le mesurer en {unit} ici. Utilisez le même type d’unité, ou changez ce que donne {child}.',
  'error.incompatibleUnitsUsedIn':
    '{usedIn} utilise {child} en {unit}, ce qui ne se déduit pas de {makes}. Modifiez d’abord cette ligne, ou gardez le rendement dans le même type d’unité.',
  'recipe.shownAsWritten':
    'Cette recette ne peut pas être calculée pour la quantité demandée ; elle s’affiche telle qu’écrite.',
  'passwordOnly.signIn': 'Se connecter avec le mot de passe',
  'passwordOnly.staff':
    'Vous êtes connecté avec votre code PIN. Pour ajouter du personnel ou changer rôles, mots de passe et codes PIN, connectez-vous avec votre mot de passe.',
  'passwordOnly.devices':
    'Vous êtes connecté avec votre code PIN. Pour enregistrer des tablettes ou autoriser des appareils extérieurs, connectez-vous avec votre mot de passe.',
  'passwordOnly.connection':
    'Vous êtes connecté avec votre code PIN. Pour changer la façon dont on accède à Mise, connectez-vous avec votre mot de passe.',
  'passwordOnly.backups':
    'Vous êtes connecté avec votre code PIN. Pour gérer les sauvegardes ou voir la clé de récupération, connectez-vous avec votre mot de passe.',
  'error.passwordRequired':
    'Connectez-vous avec votre mot de passe pour cela. Un code PIN suffit pour tout le reste.',
};
